import * as React from 'react';
import { connect } from 'react-redux';

import Page from 'components/page/Page';

import { isInsightsReportsEarlyAccessSelector } from 'selectors/insightsReportsEarlyAccess';

import { getInsightsSubnavigation } from 'utils/navigation';

import type { Organization } from 'types';

type OwnProps = {
  organization: Organization,
  documentTitle: string,
  children: React.ReactNode
};

type StateProps = {
  insightsReportsEarlyAccessIds: boolean
};

type Props = OwnProps & StateProps;

class BaseInsightsPage extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { organization, documentTitle, children, insightsReportsEarlyAccessIds } = this.props;

    return (
      <Page
        documentTitle={documentTitle}
        subnavigation={getInsightsSubnavigation(organization.id, insightsReportsEarlyAccessIds)}
      >
        {children}
      </Page>
    );
  }
}

const mapStateToProps = ({ runtimeConfig, account }): StateProps => ({
  insightsReportsEarlyAccessIds: isInsightsReportsEarlyAccessSelector({ runtimeConfig, account })
});

export default connect(mapStateToProps)(BaseInsightsPage);
